import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  rulesFileContent: {
    fontFamily: 'Courier New',
    fontWeight: 500,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  }
}));

export default useStyles;
